import * as React from 'react';
import styled from 'styled-components';
import DraftChoices from './DraftChoices';
class Content extends React.Component {
    render() {
        console.log("CONFIG", this.props.appState);
        return (React.createElement(ContentStyle, null,
            React.createElement(DraftChoices, Object.assign({}, this.props))));
    }
}
;
export default Content;
const ContentStyle = styled.div `
  background-color: #000;
  grid-area: content;
`;
//# sourceMappingURL=Content.js.map


// WEBPACK FOOTER //
// ./src/components/Content.js